class LanguageSwitcher extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  connectedCallback() {
    document.addEventListener("click", this.onDocumentClick);
    this.addEventListener("keyup", this.onKeyUp);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onDocumentClick);
    this.removeEventListener("keyup", this.onKeyUp);
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.details.removeAttribute("open");
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.details.removeAttribute("open");
    this.summary.focus();
  }
}

customElements.define("language-switcher", LanguageSwitcher);
